import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import {UserContext} from "../context/UserContext";
import ConnectAuth from "../containers/Auth/ConnectAuth";

const logo = require("../resources/img/logo.svg");

interface Props {
    locale: string;
}

export class LandingPage extends Component<Props> {
    static contextType = UserContext;
    context!: React.ContextType<typeof UserContext>;

    render(): JSX.Element {
        return (
            <div className="vault">
                <div className="hero">
                    <div className="heroOverlay"/>
                    <div className="heroContent">
                        <div className="heroBlock">
                            <img src={logo} alt="Ubisoft+" style={{height: 70}}/>
                            <h1>
                                <FormattedMessage id={"hero.title"}/>
                            </h1>
                            <h2>
                                <FormattedMessage id={"hero.subtitle"}/>
                            </h2>
                            <div className="actionButtons">
                                {this.generateActionButtons()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    generateActionButtons = (): JSX.Element => {
        if (this.context.authVerified) {
            if (this.context.user.isAuthenticated && this.context.subscriptionVerified && !this.context.user.isSubscribed) {
                return (
                    <>
                        <a className="actionButton" href="https://store.ubi.com/uplayplus" target="_blank" rel="noopener noreferrer">
                            <FormattedMessage id={"hero.buttons.subscribe"}/>
                        </a>
                        <a className="secondaryActionButton" href="https://ubi.li/Ji7Ey" target="_blank" rel="noopener noreferrer">
                            <FormattedMessage id={"hero.buttons.browse"}/>
                        </a>
                    </>
                );
            } else {
                return (
                    <>
                        <button className="actionButton" onClick={() => ConnectAuth.openConnectPopup(this.props.locale)}>
                            <FormattedMessage id={"hero.buttons.login"}/>
                        </button>
                        <a className="secondaryActionButton" href="https://store.ubi.com/uplayplus" target="_blank" rel="noopener noreferrer">
                            <FormattedMessage id={"hero.buttons.subscribe"}/>
                        </a>
                    </>
                );
            }
        } else {
            return <></>;
        }
    };
}